/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as AuthenticatedRouteImport } from "./routes/_authenticated";
import { Route as SignInRouteImport } from "./routes/sign-in";
import { Route as SignUpRouteImport } from "./routes/sign-up";
import { Route as VerifyEmailRouteImport } from "./routes/verify-email";
import { Route as AuthenticatedWorkspaceRouteImport } from "./routes/_authenticated/_workspace";
import { Route as AuthenticatedIslandRouteImport } from "./routes/_authenticated/island";
import { Route as AuthenticatedOnboardingRouteImport } from "./routes/_authenticated/onboarding";
import { Route as ConnectionsFinishedRouteImport } from "./routes/connections.finished";
import { Route as InviteIndexRouteImport } from "./routes/invite.index";
import { Route as InviteIdRouteImport } from "./routes/invite.$id";
import { Route as AuthenticatedWorkspaceConnectionsRouteImport } from "./routes/_authenticated/_workspace/connections";
import { Route as AuthenticatedWorkspaceHomeRouteImport } from "./routes/_authenticated/_workspace/home";
import { Route as AuthenticatedWorkspaceSettingsRouteImport } from "./routes/_authenticated/_workspace/settings";
import { Route as AuthenticatedWorkspaceActivityPlaybookIdRouteImport } from "./routes/_authenticated/_workspace/activity.$playbookId";
import { Route as AuthenticatedWorkspaceCasesCaseIdRouteImport } from "./routes/_authenticated/_workspace/cases.$caseId";
import { Route as AuthenticatedWorkspaceChatsIndexRouteImport } from "./routes/_authenticated/_workspace/chats.index";
import { Route as AuthenticatedWorkspaceChatsChatIdRouteImport } from "./routes/_authenticated/_workspace/chats.$chatId";
import { Route as AuthenticatedWorkspaceChatsNewRouteImport } from "./routes/_authenticated/_workspace/chats.new";
import { Route as AuthenticatedWorkspaceConnectionsIndexRouteImport } from "./routes/_authenticated/_workspace/connections.index";
import { Route as AuthenticatedWorkspaceConnectionsConnectionIdRouteImport } from "./routes/_authenticated/_workspace/connections.$connectionId";
import { Route as AuthenticatedWorkspaceConnectionsCallbackRouteImport } from "./routes/_authenticated/_workspace/connections_.callback";
import { Route as AuthenticatedWorkspacePlaybooksIndexRouteImport } from "./routes/_authenticated/_workspace/playbooks.index";
import { Route as AuthenticatedWorkspacePlaybooksPlaybookIdRouteImport } from "./routes/_authenticated/_workspace/playbooks.$playbookId";
import { Route as AuthenticatedWorkspaceSettingsIndexRouteImport } from "./routes/_authenticated/_workspace/settings.index";
import { Route as AuthenticatedWorkspaceSettingsGeneralRouteImport } from "./routes/_authenticated/_workspace/settings.general";
import { Route as AuthenticatedWorkspaceSettingsMembersRouteImport } from "./routes/_authenticated/_workspace/settings.members";
import { Route as AuthenticatedWorkspaceSettingsOrganisationRouteImport } from "./routes/_authenticated/_workspace/settings.organisation";
import { Route as AuthenticatedWorkspaceSettingsProfileRouteImport } from "./routes/_authenticated/_workspace/settings.profile";
import { Route as AuthenticatedWorkspaceTeammatesIndexRouteImport } from "./routes/_authenticated/_workspace/teammates.index";
import { Route as AuthenticatedWorkspaceTeammatesTeammateIdRouteImport } from "./routes/_authenticated/_workspace/teammates.$teammateId";
import { Route as AuthenticatedWorkspacePlaybooksPlaybookIdIndexRouteImport } from "./routes/_authenticated/_workspace/playbooks.$playbookId.index";
import { Route as AuthenticatedWorkspacePlaybooksPlaybookIdActivityRouteImport } from "./routes/_authenticated/_workspace/playbooks.$playbookId.activity";
import { Route as AuthenticatedWorkspacePlaybooksPlaybookIdConnectionsRouteImport } from "./routes/_authenticated/_workspace/playbooks.$playbookId.connections";
import { Route as AuthenticatedWorkspacePlaybooksPlaybookIdStepsRouteImport } from "./routes/_authenticated/_workspace/playbooks.$playbookId.steps";

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRouteImport,
} as any);
const SignInRoute = SignInRouteImport.update({
  id: "/sign-in",
  path: "/sign-in",
  getParentRoute: () => rootRouteImport,
} as any);
const SignUpRoute = SignUpRouteImport.update({
  id: "/sign-up",
  path: "/sign-up",
  getParentRoute: () => rootRouteImport,
} as any);
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: "/verify-email",
  path: "/verify-email",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedWorkspaceRoute = AuthenticatedWorkspaceRouteImport.update({
  id: "/_workspace",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedIslandRoute = AuthenticatedIslandRouteImport.update({
  id: "/island",
  path: "/island",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedOnboardingRoute = AuthenticatedOnboardingRouteImport.update({
  id: "/onboarding",
  path: "/onboarding",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const ConnectionsFinishedRoute = ConnectionsFinishedRouteImport.update({
  id: "/connections/finished",
  path: "/connections/finished",
  getParentRoute: () => rootRouteImport,
} as any);
const InviteIndexRoute = InviteIndexRouteImport.update({
  id: "/invite/",
  path: "/invite/",
  getParentRoute: () => rootRouteImport,
} as any);
const InviteIdRoute = InviteIdRouteImport.update({
  id: "/invite/$id",
  path: "/invite/$id",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedWorkspaceConnectionsRoute =
  AuthenticatedWorkspaceConnectionsRouteImport.update({
    id: "/connections",
    path: "/connections",
    getParentRoute: () => AuthenticatedWorkspaceRoute,
  } as any);
const AuthenticatedWorkspaceHomeRoute =
  AuthenticatedWorkspaceHomeRouteImport.update({
    id: "/home",
    path: "/home",
    getParentRoute: () => AuthenticatedWorkspaceRoute,
  } as any);
const AuthenticatedWorkspaceSettingsRoute =
  AuthenticatedWorkspaceSettingsRouteImport.update({
    id: "/settings",
    path: "/settings",
    getParentRoute: () => AuthenticatedWorkspaceRoute,
  } as any);
const AuthenticatedWorkspaceActivityPlaybookIdRoute =
  AuthenticatedWorkspaceActivityPlaybookIdRouteImport.update({
    id: "/activity/$playbookId",
    path: "/activity/$playbookId",
    getParentRoute: () => AuthenticatedWorkspaceRoute,
  } as any);
const AuthenticatedWorkspaceCasesCaseIdRoute =
  AuthenticatedWorkspaceCasesCaseIdRouteImport.update({
    id: "/cases/$caseId",
    path: "/cases/$caseId",
    getParentRoute: () => AuthenticatedWorkspaceRoute,
  } as any);
const AuthenticatedWorkspaceChatsIndexRoute =
  AuthenticatedWorkspaceChatsIndexRouteImport.update({
    id: "/chats/",
    path: "/chats/",
    getParentRoute: () => AuthenticatedWorkspaceRoute,
  } as any);
const AuthenticatedWorkspaceChatsChatIdRoute =
  AuthenticatedWorkspaceChatsChatIdRouteImport.update({
    id: "/chats/$chatId",
    path: "/chats/$chatId",
    getParentRoute: () => AuthenticatedWorkspaceRoute,
  } as any);
const AuthenticatedWorkspaceChatsNewRoute =
  AuthenticatedWorkspaceChatsNewRouteImport.update({
    id: "/chats/new",
    path: "/chats/new",
    getParentRoute: () => AuthenticatedWorkspaceRoute,
  } as any);
const AuthenticatedWorkspaceConnectionsIndexRoute =
  AuthenticatedWorkspaceConnectionsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedWorkspaceConnectionsRoute,
  } as any);
const AuthenticatedWorkspaceConnectionsConnectionIdRoute =
  AuthenticatedWorkspaceConnectionsConnectionIdRouteImport.update({
    id: "/$connectionId",
    path: "/$connectionId",
    getParentRoute: () => AuthenticatedWorkspaceConnectionsRoute,
  } as any);
const AuthenticatedWorkspaceConnectionsCallbackRoute =
  AuthenticatedWorkspaceConnectionsCallbackRouteImport.update({
    id: "/connections_/callback",
    path: "/connections/callback",
    getParentRoute: () => AuthenticatedWorkspaceRoute,
  } as any);
const AuthenticatedWorkspacePlaybooksIndexRoute =
  AuthenticatedWorkspacePlaybooksIndexRouteImport.update({
    id: "/playbooks/",
    path: "/playbooks/",
    getParentRoute: () => AuthenticatedWorkspaceRoute,
  } as any);
const AuthenticatedWorkspacePlaybooksPlaybookIdRoute =
  AuthenticatedWorkspacePlaybooksPlaybookIdRouteImport.update({
    id: "/playbooks/$playbookId",
    path: "/playbooks/$playbookId",
    getParentRoute: () => AuthenticatedWorkspaceRoute,
  } as any);
const AuthenticatedWorkspaceSettingsIndexRoute =
  AuthenticatedWorkspaceSettingsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedWorkspaceSettingsRoute,
  } as any);
const AuthenticatedWorkspaceSettingsGeneralRoute =
  AuthenticatedWorkspaceSettingsGeneralRouteImport.update({
    id: "/general",
    path: "/general",
    getParentRoute: () => AuthenticatedWorkspaceSettingsRoute,
  } as any);
const AuthenticatedWorkspaceSettingsMembersRoute =
  AuthenticatedWorkspaceSettingsMembersRouteImport.update({
    id: "/members",
    path: "/members",
    getParentRoute: () => AuthenticatedWorkspaceSettingsRoute,
  } as any);
const AuthenticatedWorkspaceSettingsOrganisationRoute =
  AuthenticatedWorkspaceSettingsOrganisationRouteImport.update({
    id: "/organisation",
    path: "/organisation",
    getParentRoute: () => AuthenticatedWorkspaceSettingsRoute,
  } as any);
const AuthenticatedWorkspaceSettingsProfileRoute =
  AuthenticatedWorkspaceSettingsProfileRouteImport.update({
    id: "/profile",
    path: "/profile",
    getParentRoute: () => AuthenticatedWorkspaceSettingsRoute,
  } as any);
const AuthenticatedWorkspaceTeammatesIndexRoute =
  AuthenticatedWorkspaceTeammatesIndexRouteImport.update({
    id: "/teammates/",
    path: "/teammates/",
    getParentRoute: () => AuthenticatedWorkspaceRoute,
  } as any);
const AuthenticatedWorkspaceTeammatesTeammateIdRoute =
  AuthenticatedWorkspaceTeammatesTeammateIdRouteImport.update({
    id: "/teammates/$teammateId",
    path: "/teammates/$teammateId",
    getParentRoute: () => AuthenticatedWorkspaceRoute,
  } as any);
const AuthenticatedWorkspacePlaybooksPlaybookIdIndexRoute =
  AuthenticatedWorkspacePlaybooksPlaybookIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedWorkspacePlaybooksPlaybookIdRoute,
  } as any);
const AuthenticatedWorkspacePlaybooksPlaybookIdActivityRoute =
  AuthenticatedWorkspacePlaybooksPlaybookIdActivityRouteImport.update({
    id: "/activity",
    path: "/activity",
    getParentRoute: () => AuthenticatedWorkspacePlaybooksPlaybookIdRoute,
  } as any);
const AuthenticatedWorkspacePlaybooksPlaybookIdConnectionsRoute =
  AuthenticatedWorkspacePlaybooksPlaybookIdConnectionsRouteImport.update({
    id: "/connections",
    path: "/connections",
    getParentRoute: () => AuthenticatedWorkspacePlaybooksPlaybookIdRoute,
  } as any);
const AuthenticatedWorkspacePlaybooksPlaybookIdStepsRoute =
  AuthenticatedWorkspacePlaybooksPlaybookIdStepsRouteImport.update({
    id: "/steps",
    path: "/steps",
    getParentRoute: () => AuthenticatedWorkspacePlaybooksPlaybookIdRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/sign-in": typeof SignInRoute;
  "/sign-up": typeof SignUpRoute;
  "/verify-email": typeof VerifyEmailRoute;
  "/island": typeof AuthenticatedIslandRoute;
  "/onboarding": typeof AuthenticatedOnboardingRoute;
  "/connections/finished": typeof ConnectionsFinishedRoute;
  "/invite/$id": typeof InviteIdRoute;
  "/invite/": typeof InviteIndexRoute;
  "/connections": typeof AuthenticatedWorkspaceConnectionsRouteWithChildren;
  "/home": typeof AuthenticatedWorkspaceHomeRoute;
  "/settings": typeof AuthenticatedWorkspaceSettingsRouteWithChildren;
  "/activity/$playbookId": typeof AuthenticatedWorkspaceActivityPlaybookIdRoute;
  "/cases/$caseId": typeof AuthenticatedWorkspaceCasesCaseIdRoute;
  "/chats/$chatId": typeof AuthenticatedWorkspaceChatsChatIdRoute;
  "/chats/new": typeof AuthenticatedWorkspaceChatsNewRoute;
  "/connections/$connectionId": typeof AuthenticatedWorkspaceConnectionsConnectionIdRoute;
  "/connections/callback": typeof AuthenticatedWorkspaceConnectionsCallbackRoute;
  "/playbooks/$playbookId": typeof AuthenticatedWorkspacePlaybooksPlaybookIdRouteWithChildren;
  "/settings/general": typeof AuthenticatedWorkspaceSettingsGeneralRoute;
  "/settings/members": typeof AuthenticatedWorkspaceSettingsMembersRoute;
  "/settings/organisation": typeof AuthenticatedWorkspaceSettingsOrganisationRoute;
  "/settings/profile": typeof AuthenticatedWorkspaceSettingsProfileRoute;
  "/teammates/$teammateId": typeof AuthenticatedWorkspaceTeammatesTeammateIdRoute;
  "/chats/": typeof AuthenticatedWorkspaceChatsIndexRoute;
  "/connections/": typeof AuthenticatedWorkspaceConnectionsIndexRoute;
  "/playbooks/": typeof AuthenticatedWorkspacePlaybooksIndexRoute;
  "/settings/": typeof AuthenticatedWorkspaceSettingsIndexRoute;
  "/teammates/": typeof AuthenticatedWorkspaceTeammatesIndexRoute;
  "/playbooks/$playbookId/activity": typeof AuthenticatedWorkspacePlaybooksPlaybookIdActivityRoute;
  "/playbooks/$playbookId/connections": typeof AuthenticatedWorkspacePlaybooksPlaybookIdConnectionsRoute;
  "/playbooks/$playbookId/steps": typeof AuthenticatedWorkspacePlaybooksPlaybookIdStepsRoute;
  "/playbooks/$playbookId/": typeof AuthenticatedWorkspacePlaybooksPlaybookIdIndexRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/sign-in": typeof SignInRoute;
  "/sign-up": typeof SignUpRoute;
  "/verify-email": typeof VerifyEmailRoute;
  "/island": typeof AuthenticatedIslandRoute;
  "/onboarding": typeof AuthenticatedOnboardingRoute;
  "/connections/finished": typeof ConnectionsFinishedRoute;
  "/invite/$id": typeof InviteIdRoute;
  "/invite": typeof InviteIndexRoute;
  "/home": typeof AuthenticatedWorkspaceHomeRoute;
  "/activity/$playbookId": typeof AuthenticatedWorkspaceActivityPlaybookIdRoute;
  "/cases/$caseId": typeof AuthenticatedWorkspaceCasesCaseIdRoute;
  "/chats/$chatId": typeof AuthenticatedWorkspaceChatsChatIdRoute;
  "/chats/new": typeof AuthenticatedWorkspaceChatsNewRoute;
  "/connections/$connectionId": typeof AuthenticatedWorkspaceConnectionsConnectionIdRoute;
  "/connections/callback": typeof AuthenticatedWorkspaceConnectionsCallbackRoute;
  "/settings/general": typeof AuthenticatedWorkspaceSettingsGeneralRoute;
  "/settings/members": typeof AuthenticatedWorkspaceSettingsMembersRoute;
  "/settings/organisation": typeof AuthenticatedWorkspaceSettingsOrganisationRoute;
  "/settings/profile": typeof AuthenticatedWorkspaceSettingsProfileRoute;
  "/teammates/$teammateId": typeof AuthenticatedWorkspaceTeammatesTeammateIdRoute;
  "/chats": typeof AuthenticatedWorkspaceChatsIndexRoute;
  "/connections": typeof AuthenticatedWorkspaceConnectionsIndexRoute;
  "/playbooks": typeof AuthenticatedWorkspacePlaybooksIndexRoute;
  "/settings": typeof AuthenticatedWorkspaceSettingsIndexRoute;
  "/teammates": typeof AuthenticatedWorkspaceTeammatesIndexRoute;
  "/playbooks/$playbookId/activity": typeof AuthenticatedWorkspacePlaybooksPlaybookIdActivityRoute;
  "/playbooks/$playbookId/connections": typeof AuthenticatedWorkspacePlaybooksPlaybookIdConnectionsRoute;
  "/playbooks/$playbookId/steps": typeof AuthenticatedWorkspacePlaybooksPlaybookIdStepsRoute;
  "/playbooks/$playbookId": typeof AuthenticatedWorkspacePlaybooksPlaybookIdIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/_authenticated": typeof AuthenticatedRouteWithChildren;
  "/sign-in": typeof SignInRoute;
  "/sign-up": typeof SignUpRoute;
  "/verify-email": typeof VerifyEmailRoute;
  "/_authenticated/_workspace": typeof AuthenticatedWorkspaceRouteWithChildren;
  "/_authenticated/island": typeof AuthenticatedIslandRoute;
  "/_authenticated/onboarding": typeof AuthenticatedOnboardingRoute;
  "/connections/finished": typeof ConnectionsFinishedRoute;
  "/invite/$id": typeof InviteIdRoute;
  "/invite/": typeof InviteIndexRoute;
  "/_authenticated/_workspace/connections": typeof AuthenticatedWorkspaceConnectionsRouteWithChildren;
  "/_authenticated/_workspace/home": typeof AuthenticatedWorkspaceHomeRoute;
  "/_authenticated/_workspace/settings": typeof AuthenticatedWorkspaceSettingsRouteWithChildren;
  "/_authenticated/_workspace/activity/$playbookId": typeof AuthenticatedWorkspaceActivityPlaybookIdRoute;
  "/_authenticated/_workspace/cases/$caseId": typeof AuthenticatedWorkspaceCasesCaseIdRoute;
  "/_authenticated/_workspace/chats/$chatId": typeof AuthenticatedWorkspaceChatsChatIdRoute;
  "/_authenticated/_workspace/chats/new": typeof AuthenticatedWorkspaceChatsNewRoute;
  "/_authenticated/_workspace/connections/$connectionId": typeof AuthenticatedWorkspaceConnectionsConnectionIdRoute;
  "/_authenticated/_workspace/connections_/callback": typeof AuthenticatedWorkspaceConnectionsCallbackRoute;
  "/_authenticated/_workspace/playbooks/$playbookId": typeof AuthenticatedWorkspacePlaybooksPlaybookIdRouteWithChildren;
  "/_authenticated/_workspace/settings/general": typeof AuthenticatedWorkspaceSettingsGeneralRoute;
  "/_authenticated/_workspace/settings/members": typeof AuthenticatedWorkspaceSettingsMembersRoute;
  "/_authenticated/_workspace/settings/organisation": typeof AuthenticatedWorkspaceSettingsOrganisationRoute;
  "/_authenticated/_workspace/settings/profile": typeof AuthenticatedWorkspaceSettingsProfileRoute;
  "/_authenticated/_workspace/teammates/$teammateId": typeof AuthenticatedWorkspaceTeammatesTeammateIdRoute;
  "/_authenticated/_workspace/chats/": typeof AuthenticatedWorkspaceChatsIndexRoute;
  "/_authenticated/_workspace/connections/": typeof AuthenticatedWorkspaceConnectionsIndexRoute;
  "/_authenticated/_workspace/playbooks/": typeof AuthenticatedWorkspacePlaybooksIndexRoute;
  "/_authenticated/_workspace/settings/": typeof AuthenticatedWorkspaceSettingsIndexRoute;
  "/_authenticated/_workspace/teammates/": typeof AuthenticatedWorkspaceTeammatesIndexRoute;
  "/_authenticated/_workspace/playbooks/$playbookId/activity": typeof AuthenticatedWorkspacePlaybooksPlaybookIdActivityRoute;
  "/_authenticated/_workspace/playbooks/$playbookId/connections": typeof AuthenticatedWorkspacePlaybooksPlaybookIdConnectionsRoute;
  "/_authenticated/_workspace/playbooks/$playbookId/steps": typeof AuthenticatedWorkspacePlaybooksPlaybookIdStepsRoute;
  "/_authenticated/_workspace/playbooks/$playbookId/": typeof AuthenticatedWorkspacePlaybooksPlaybookIdIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/sign-in"
    | "/sign-up"
    | "/verify-email"
    | "/island"
    | "/onboarding"
    | "/connections/finished"
    | "/invite/$id"
    | "/invite/"
    | "/connections"
    | "/home"
    | "/settings"
    | "/activity/$playbookId"
    | "/cases/$caseId"
    | "/chats/$chatId"
    | "/chats/new"
    | "/connections/$connectionId"
    | "/connections/callback"
    | "/playbooks/$playbookId"
    | "/settings/general"
    | "/settings/members"
    | "/settings/organisation"
    | "/settings/profile"
    | "/teammates/$teammateId"
    | "/chats/"
    | "/connections/"
    | "/playbooks/"
    | "/settings/"
    | "/teammates/"
    | "/playbooks/$playbookId/activity"
    | "/playbooks/$playbookId/connections"
    | "/playbooks/$playbookId/steps"
    | "/playbooks/$playbookId/";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/sign-in"
    | "/sign-up"
    | "/verify-email"
    | "/island"
    | "/onboarding"
    | "/connections/finished"
    | "/invite/$id"
    | "/invite"
    | "/home"
    | "/activity/$playbookId"
    | "/cases/$caseId"
    | "/chats/$chatId"
    | "/chats/new"
    | "/connections/$connectionId"
    | "/connections/callback"
    | "/settings/general"
    | "/settings/members"
    | "/settings/organisation"
    | "/settings/profile"
    | "/teammates/$teammateId"
    | "/chats"
    | "/connections"
    | "/playbooks"
    | "/settings"
    | "/teammates"
    | "/playbooks/$playbookId/activity"
    | "/playbooks/$playbookId/connections"
    | "/playbooks/$playbookId/steps"
    | "/playbooks/$playbookId";
  id:
    | "__root__"
    | "/"
    | "/_authenticated"
    | "/sign-in"
    | "/sign-up"
    | "/verify-email"
    | "/_authenticated/_workspace"
    | "/_authenticated/island"
    | "/_authenticated/onboarding"
    | "/connections/finished"
    | "/invite/$id"
    | "/invite/"
    | "/_authenticated/_workspace/connections"
    | "/_authenticated/_workspace/home"
    | "/_authenticated/_workspace/settings"
    | "/_authenticated/_workspace/activity/$playbookId"
    | "/_authenticated/_workspace/cases/$caseId"
    | "/_authenticated/_workspace/chats/$chatId"
    | "/_authenticated/_workspace/chats/new"
    | "/_authenticated/_workspace/connections/$connectionId"
    | "/_authenticated/_workspace/connections_/callback"
    | "/_authenticated/_workspace/playbooks/$playbookId"
    | "/_authenticated/_workspace/settings/general"
    | "/_authenticated/_workspace/settings/members"
    | "/_authenticated/_workspace/settings/organisation"
    | "/_authenticated/_workspace/settings/profile"
    | "/_authenticated/_workspace/teammates/$teammateId"
    | "/_authenticated/_workspace/chats/"
    | "/_authenticated/_workspace/connections/"
    | "/_authenticated/_workspace/playbooks/"
    | "/_authenticated/_workspace/settings/"
    | "/_authenticated/_workspace/teammates/"
    | "/_authenticated/_workspace/playbooks/$playbookId/activity"
    | "/_authenticated/_workspace/playbooks/$playbookId/connections"
    | "/_authenticated/_workspace/playbooks/$playbookId/steps"
    | "/_authenticated/_workspace/playbooks/$playbookId/";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren;
  SignInRoute: typeof SignInRoute;
  SignUpRoute: typeof SignUpRoute;
  VerifyEmailRoute: typeof VerifyEmailRoute;
  ConnectionsFinishedRoute: typeof ConnectionsFinishedRoute;
  InviteIdRoute: typeof InviteIdRoute;
  InviteIndexRoute: typeof InviteIndexRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated": {
      id: "/_authenticated";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AuthenticatedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/sign-in": {
      id: "/sign-in";
      path: "/sign-in";
      fullPath: "/sign-in";
      preLoaderRoute: typeof SignInRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/sign-up": {
      id: "/sign-up";
      path: "/sign-up";
      fullPath: "/sign-up";
      preLoaderRoute: typeof SignUpRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/verify-email": {
      id: "/verify-email";
      path: "/verify-email";
      fullPath: "/verify-email";
      preLoaderRoute: typeof VerifyEmailRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated/_workspace": {
      id: "/_authenticated/_workspace";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AuthenticatedWorkspaceRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/island": {
      id: "/_authenticated/island";
      path: "/island";
      fullPath: "/island";
      preLoaderRoute: typeof AuthenticatedIslandRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/onboarding": {
      id: "/_authenticated/onboarding";
      path: "/onboarding";
      fullPath: "/onboarding";
      preLoaderRoute: typeof AuthenticatedOnboardingRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/connections/finished": {
      id: "/connections/finished";
      path: "/connections/finished";
      fullPath: "/connections/finished";
      preLoaderRoute: typeof ConnectionsFinishedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/invite/": {
      id: "/invite/";
      path: "/invite";
      fullPath: "/invite/";
      preLoaderRoute: typeof InviteIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/invite/$id": {
      id: "/invite/$id";
      path: "/invite/$id";
      fullPath: "/invite/$id";
      preLoaderRoute: typeof InviteIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated/_workspace/connections": {
      id: "/_authenticated/_workspace/connections";
      path: "/connections";
      fullPath: "/connections";
      preLoaderRoute: typeof AuthenticatedWorkspaceConnectionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspaceRoute;
    };
    "/_authenticated/_workspace/home": {
      id: "/_authenticated/_workspace/home";
      path: "/home";
      fullPath: "/home";
      preLoaderRoute: typeof AuthenticatedWorkspaceHomeRouteImport;
      parentRoute: typeof AuthenticatedWorkspaceRoute;
    };
    "/_authenticated/_workspace/settings": {
      id: "/_authenticated/_workspace/settings";
      path: "/settings";
      fullPath: "/settings";
      preLoaderRoute: typeof AuthenticatedWorkspaceSettingsRouteImport;
      parentRoute: typeof AuthenticatedWorkspaceRoute;
    };
    "/_authenticated/_workspace/activity/$playbookId": {
      id: "/_authenticated/_workspace/activity/$playbookId";
      path: "/activity/$playbookId";
      fullPath: "/activity/$playbookId";
      preLoaderRoute: typeof AuthenticatedWorkspaceActivityPlaybookIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspaceRoute;
    };
    "/_authenticated/_workspace/cases/$caseId": {
      id: "/_authenticated/_workspace/cases/$caseId";
      path: "/cases/$caseId";
      fullPath: "/cases/$caseId";
      preLoaderRoute: typeof AuthenticatedWorkspaceCasesCaseIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspaceRoute;
    };
    "/_authenticated/_workspace/chats/": {
      id: "/_authenticated/_workspace/chats/";
      path: "/chats";
      fullPath: "/chats/";
      preLoaderRoute: typeof AuthenticatedWorkspaceChatsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspaceRoute;
    };
    "/_authenticated/_workspace/chats/$chatId": {
      id: "/_authenticated/_workspace/chats/$chatId";
      path: "/chats/$chatId";
      fullPath: "/chats/$chatId";
      preLoaderRoute: typeof AuthenticatedWorkspaceChatsChatIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspaceRoute;
    };
    "/_authenticated/_workspace/chats/new": {
      id: "/_authenticated/_workspace/chats/new";
      path: "/chats/new";
      fullPath: "/chats/new";
      preLoaderRoute: typeof AuthenticatedWorkspaceChatsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspaceRoute;
    };
    "/_authenticated/_workspace/connections/": {
      id: "/_authenticated/_workspace/connections/";
      path: "/";
      fullPath: "/connections/";
      preLoaderRoute: typeof AuthenticatedWorkspaceConnectionsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspaceConnectionsRoute;
    };
    "/_authenticated/_workspace/connections/$connectionId": {
      id: "/_authenticated/_workspace/connections/$connectionId";
      path: "/$connectionId";
      fullPath: "/connections/$connectionId";
      preLoaderRoute: typeof AuthenticatedWorkspaceConnectionsConnectionIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspaceConnectionsRoute;
    };
    "/_authenticated/_workspace/connections_/callback": {
      id: "/_authenticated/_workspace/connections_/callback";
      path: "/connections/callback";
      fullPath: "/connections/callback";
      preLoaderRoute: typeof AuthenticatedWorkspaceConnectionsCallbackRouteImport;
      parentRoute: typeof AuthenticatedWorkspaceRoute;
    };
    "/_authenticated/_workspace/playbooks/": {
      id: "/_authenticated/_workspace/playbooks/";
      path: "/playbooks";
      fullPath: "/playbooks/";
      preLoaderRoute: typeof AuthenticatedWorkspacePlaybooksIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspaceRoute;
    };
    "/_authenticated/_workspace/playbooks/$playbookId": {
      id: "/_authenticated/_workspace/playbooks/$playbookId";
      path: "/playbooks/$playbookId";
      fullPath: "/playbooks/$playbookId";
      preLoaderRoute: typeof AuthenticatedWorkspacePlaybooksPlaybookIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspaceRoute;
    };
    "/_authenticated/_workspace/settings/": {
      id: "/_authenticated/_workspace/settings/";
      path: "/";
      fullPath: "/settings/";
      preLoaderRoute: typeof AuthenticatedWorkspaceSettingsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspaceSettingsRoute;
    };
    "/_authenticated/_workspace/settings/general": {
      id: "/_authenticated/_workspace/settings/general";
      path: "/general";
      fullPath: "/settings/general";
      preLoaderRoute: typeof AuthenticatedWorkspaceSettingsGeneralRouteImport;
      parentRoute: typeof AuthenticatedWorkspaceSettingsRoute;
    };
    "/_authenticated/_workspace/settings/members": {
      id: "/_authenticated/_workspace/settings/members";
      path: "/members";
      fullPath: "/settings/members";
      preLoaderRoute: typeof AuthenticatedWorkspaceSettingsMembersRouteImport;
      parentRoute: typeof AuthenticatedWorkspaceSettingsRoute;
    };
    "/_authenticated/_workspace/settings/organisation": {
      id: "/_authenticated/_workspace/settings/organisation";
      path: "/organisation";
      fullPath: "/settings/organisation";
      preLoaderRoute: typeof AuthenticatedWorkspaceSettingsOrganisationRouteImport;
      parentRoute: typeof AuthenticatedWorkspaceSettingsRoute;
    };
    "/_authenticated/_workspace/settings/profile": {
      id: "/_authenticated/_workspace/settings/profile";
      path: "/profile";
      fullPath: "/settings/profile";
      preLoaderRoute: typeof AuthenticatedWorkspaceSettingsProfileRouteImport;
      parentRoute: typeof AuthenticatedWorkspaceSettingsRoute;
    };
    "/_authenticated/_workspace/teammates/": {
      id: "/_authenticated/_workspace/teammates/";
      path: "/teammates";
      fullPath: "/teammates/";
      preLoaderRoute: typeof AuthenticatedWorkspaceTeammatesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspaceRoute;
    };
    "/_authenticated/_workspace/teammates/$teammateId": {
      id: "/_authenticated/_workspace/teammates/$teammateId";
      path: "/teammates/$teammateId";
      fullPath: "/teammates/$teammateId";
      preLoaderRoute: typeof AuthenticatedWorkspaceTeammatesTeammateIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspaceRoute;
    };
    "/_authenticated/_workspace/playbooks/$playbookId/": {
      id: "/_authenticated/_workspace/playbooks/$playbookId/";
      path: "/";
      fullPath: "/playbooks/$playbookId/";
      preLoaderRoute: typeof AuthenticatedWorkspacePlaybooksPlaybookIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacePlaybooksPlaybookIdRoute;
    };
    "/_authenticated/_workspace/playbooks/$playbookId/activity": {
      id: "/_authenticated/_workspace/playbooks/$playbookId/activity";
      path: "/activity";
      fullPath: "/playbooks/$playbookId/activity";
      preLoaderRoute: typeof AuthenticatedWorkspacePlaybooksPlaybookIdActivityRouteImport;
      parentRoute: typeof AuthenticatedWorkspacePlaybooksPlaybookIdRoute;
    };
    "/_authenticated/_workspace/playbooks/$playbookId/connections": {
      id: "/_authenticated/_workspace/playbooks/$playbookId/connections";
      path: "/connections";
      fullPath: "/playbooks/$playbookId/connections";
      preLoaderRoute: typeof AuthenticatedWorkspacePlaybooksPlaybookIdConnectionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacePlaybooksPlaybookIdRoute;
    };
    "/_authenticated/_workspace/playbooks/$playbookId/steps": {
      id: "/_authenticated/_workspace/playbooks/$playbookId/steps";
      path: "/steps";
      fullPath: "/playbooks/$playbookId/steps";
      preLoaderRoute: typeof AuthenticatedWorkspacePlaybooksPlaybookIdStepsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacePlaybooksPlaybookIdRoute;
    };
  }
}

interface AuthenticatedWorkspaceConnectionsRouteChildren {
  AuthenticatedWorkspaceConnectionsConnectionIdRoute: typeof AuthenticatedWorkspaceConnectionsConnectionIdRoute;
  AuthenticatedWorkspaceConnectionsIndexRoute: typeof AuthenticatedWorkspaceConnectionsIndexRoute;
}

const AuthenticatedWorkspaceConnectionsRouteChildren: AuthenticatedWorkspaceConnectionsRouteChildren =
  {
    AuthenticatedWorkspaceConnectionsConnectionIdRoute:
      AuthenticatedWorkspaceConnectionsConnectionIdRoute,
    AuthenticatedWorkspaceConnectionsIndexRoute:
      AuthenticatedWorkspaceConnectionsIndexRoute,
  };

const AuthenticatedWorkspaceConnectionsRouteWithChildren =
  AuthenticatedWorkspaceConnectionsRoute._addFileChildren(
    AuthenticatedWorkspaceConnectionsRouteChildren,
  );

interface AuthenticatedWorkspaceSettingsRouteChildren {
  AuthenticatedWorkspaceSettingsGeneralRoute: typeof AuthenticatedWorkspaceSettingsGeneralRoute;
  AuthenticatedWorkspaceSettingsMembersRoute: typeof AuthenticatedWorkspaceSettingsMembersRoute;
  AuthenticatedWorkspaceSettingsOrganisationRoute: typeof AuthenticatedWorkspaceSettingsOrganisationRoute;
  AuthenticatedWorkspaceSettingsProfileRoute: typeof AuthenticatedWorkspaceSettingsProfileRoute;
  AuthenticatedWorkspaceSettingsIndexRoute: typeof AuthenticatedWorkspaceSettingsIndexRoute;
}

const AuthenticatedWorkspaceSettingsRouteChildren: AuthenticatedWorkspaceSettingsRouteChildren =
  {
    AuthenticatedWorkspaceSettingsGeneralRoute:
      AuthenticatedWorkspaceSettingsGeneralRoute,
    AuthenticatedWorkspaceSettingsMembersRoute:
      AuthenticatedWorkspaceSettingsMembersRoute,
    AuthenticatedWorkspaceSettingsOrganisationRoute:
      AuthenticatedWorkspaceSettingsOrganisationRoute,
    AuthenticatedWorkspaceSettingsProfileRoute:
      AuthenticatedWorkspaceSettingsProfileRoute,
    AuthenticatedWorkspaceSettingsIndexRoute:
      AuthenticatedWorkspaceSettingsIndexRoute,
  };

const AuthenticatedWorkspaceSettingsRouteWithChildren =
  AuthenticatedWorkspaceSettingsRoute._addFileChildren(
    AuthenticatedWorkspaceSettingsRouteChildren,
  );

interface AuthenticatedWorkspacePlaybooksPlaybookIdRouteChildren {
  AuthenticatedWorkspacePlaybooksPlaybookIdActivityRoute: typeof AuthenticatedWorkspacePlaybooksPlaybookIdActivityRoute;
  AuthenticatedWorkspacePlaybooksPlaybookIdConnectionsRoute: typeof AuthenticatedWorkspacePlaybooksPlaybookIdConnectionsRoute;
  AuthenticatedWorkspacePlaybooksPlaybookIdStepsRoute: typeof AuthenticatedWorkspacePlaybooksPlaybookIdStepsRoute;
  AuthenticatedWorkspacePlaybooksPlaybookIdIndexRoute: typeof AuthenticatedWorkspacePlaybooksPlaybookIdIndexRoute;
}

const AuthenticatedWorkspacePlaybooksPlaybookIdRouteChildren: AuthenticatedWorkspacePlaybooksPlaybookIdRouteChildren =
  {
    AuthenticatedWorkspacePlaybooksPlaybookIdActivityRoute:
      AuthenticatedWorkspacePlaybooksPlaybookIdActivityRoute,
    AuthenticatedWorkspacePlaybooksPlaybookIdConnectionsRoute:
      AuthenticatedWorkspacePlaybooksPlaybookIdConnectionsRoute,
    AuthenticatedWorkspacePlaybooksPlaybookIdStepsRoute:
      AuthenticatedWorkspacePlaybooksPlaybookIdStepsRoute,
    AuthenticatedWorkspacePlaybooksPlaybookIdIndexRoute:
      AuthenticatedWorkspacePlaybooksPlaybookIdIndexRoute,
  };

const AuthenticatedWorkspacePlaybooksPlaybookIdRouteWithChildren =
  AuthenticatedWorkspacePlaybooksPlaybookIdRoute._addFileChildren(
    AuthenticatedWorkspacePlaybooksPlaybookIdRouteChildren,
  );

interface AuthenticatedWorkspaceRouteChildren {
  AuthenticatedWorkspaceConnectionsRoute: typeof AuthenticatedWorkspaceConnectionsRouteWithChildren;
  AuthenticatedWorkspaceHomeRoute: typeof AuthenticatedWorkspaceHomeRoute;
  AuthenticatedWorkspaceSettingsRoute: typeof AuthenticatedWorkspaceSettingsRouteWithChildren;
  AuthenticatedWorkspaceActivityPlaybookIdRoute: typeof AuthenticatedWorkspaceActivityPlaybookIdRoute;
  AuthenticatedWorkspaceCasesCaseIdRoute: typeof AuthenticatedWorkspaceCasesCaseIdRoute;
  AuthenticatedWorkspaceChatsChatIdRoute: typeof AuthenticatedWorkspaceChatsChatIdRoute;
  AuthenticatedWorkspaceChatsNewRoute: typeof AuthenticatedWorkspaceChatsNewRoute;
  AuthenticatedWorkspaceConnectionsCallbackRoute: typeof AuthenticatedWorkspaceConnectionsCallbackRoute;
  AuthenticatedWorkspacePlaybooksPlaybookIdRoute: typeof AuthenticatedWorkspacePlaybooksPlaybookIdRouteWithChildren;
  AuthenticatedWorkspaceTeammatesTeammateIdRoute: typeof AuthenticatedWorkspaceTeammatesTeammateIdRoute;
  AuthenticatedWorkspaceChatsIndexRoute: typeof AuthenticatedWorkspaceChatsIndexRoute;
  AuthenticatedWorkspacePlaybooksIndexRoute: typeof AuthenticatedWorkspacePlaybooksIndexRoute;
  AuthenticatedWorkspaceTeammatesIndexRoute: typeof AuthenticatedWorkspaceTeammatesIndexRoute;
}

const AuthenticatedWorkspaceRouteChildren: AuthenticatedWorkspaceRouteChildren =
  {
    AuthenticatedWorkspaceConnectionsRoute:
      AuthenticatedWorkspaceConnectionsRouteWithChildren,
    AuthenticatedWorkspaceHomeRoute: AuthenticatedWorkspaceHomeRoute,
    AuthenticatedWorkspaceSettingsRoute:
      AuthenticatedWorkspaceSettingsRouteWithChildren,
    AuthenticatedWorkspaceActivityPlaybookIdRoute:
      AuthenticatedWorkspaceActivityPlaybookIdRoute,
    AuthenticatedWorkspaceCasesCaseIdRoute:
      AuthenticatedWorkspaceCasesCaseIdRoute,
    AuthenticatedWorkspaceChatsChatIdRoute:
      AuthenticatedWorkspaceChatsChatIdRoute,
    AuthenticatedWorkspaceChatsNewRoute: AuthenticatedWorkspaceChatsNewRoute,
    AuthenticatedWorkspaceConnectionsCallbackRoute:
      AuthenticatedWorkspaceConnectionsCallbackRoute,
    AuthenticatedWorkspacePlaybooksPlaybookIdRoute:
      AuthenticatedWorkspacePlaybooksPlaybookIdRouteWithChildren,
    AuthenticatedWorkspaceTeammatesTeammateIdRoute:
      AuthenticatedWorkspaceTeammatesTeammateIdRoute,
    AuthenticatedWorkspaceChatsIndexRoute:
      AuthenticatedWorkspaceChatsIndexRoute,
    AuthenticatedWorkspacePlaybooksIndexRoute:
      AuthenticatedWorkspacePlaybooksIndexRoute,
    AuthenticatedWorkspaceTeammatesIndexRoute:
      AuthenticatedWorkspaceTeammatesIndexRoute,
  };

const AuthenticatedWorkspaceRouteWithChildren =
  AuthenticatedWorkspaceRoute._addFileChildren(
    AuthenticatedWorkspaceRouteChildren,
  );

interface AuthenticatedRouteChildren {
  AuthenticatedWorkspaceRoute: typeof AuthenticatedWorkspaceRouteWithChildren;
  AuthenticatedIslandRoute: typeof AuthenticatedIslandRoute;
  AuthenticatedOnboardingRoute: typeof AuthenticatedOnboardingRoute;
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedWorkspaceRoute: AuthenticatedWorkspaceRouteWithChildren,
  AuthenticatedIslandRoute: AuthenticatedIslandRoute,
  AuthenticatedOnboardingRoute: AuthenticatedOnboardingRoute,
};

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  ConnectionsFinishedRoute: ConnectionsFinishedRoute,
  InviteIdRoute: InviteIdRoute,
  InviteIndexRoute: InviteIndexRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
